import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { ConditionDisplay } from '../../../model/condition/condition.model';
import { ConditionDisplayType } from '../../../model/constant';

@Component({
  selector: 'act-dialog-condition-change',
  templateUrl: './dialog-condition-change.component.html',
  styleUrls: ['./dialog-condition-change.component.scss']
})

export class DialogConditionChangeComponent implements OnInit {
  private isMobile = false;
  private title: string;
  private description: string;
  private columns: string[];
  private data: string[][];
  private type: string;
  private route: string;
  private isVerticalDisplayMobile: boolean;
  private conditionDisplayType = ConditionDisplayType;
  private imgPath: string;
  private btn: string[];
  private noOfColumns: number;

  constructor(
    @Inject(MD_DIALOG_DATA) public inputData: ConditionDisplay,
    public dialogRef: MdDialogRef<DialogConditionChangeComponent>,
    private utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this.utilitiesService.isMobile() && (this.isMobile = true);
    this.checkUIcondition(this.inputData);
  }

  checkUIcondition(inputData) {
    switch (inputData.code) {
      case '4071': case '4072': case '4078':
        this.title = inputData.title;
        this.columns = inputData.columns;
        this.data = inputData.row;
        this.noOfColumns = this.columns.length;
        this.type = ConditionDisplayType.TABLE;
        break;
      case '4075': case '4076': case '4077':
        this.title = inputData.title;
        this.type = ConditionDisplayType.TWO_BUTTON;
        break;
      case '4081': case '4082': case '4083': case '4731':
      case '4701': case '4717': case '4084': case '4811':
      case '4807':
        this.description = inputData.title;
        this.type = ConditionDisplayType.ONE_BUTTON_DIVIDER;
        break;
      case '4091': case '4092': case '4711': 
        this.title = inputData.title;
        this.description = inputData.description;
        this.type = ConditionDisplayType.ONE_BUTTON_DIVIDER;
    }
    this.btn = inputData.btn;
    this.isVerticalDisplayMobile = this.inputData.isVerticalDisplayMobile;
    this.route = inputData.route;
    this.imgPath = inputData.imgPath;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = this.utilitiesService.isMobile();
  }

  acceptChange() {
    this.handleSuccess();
  }

  goToHome() {
    this.handleFailure();
  }

  handleSuccess() {
    this.dialogRef.close({ status: true, type: this.type, route: this.inputData.route });
  }

  handleFailure() {
    this.dialogRef.close({ status: false });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-condition-change/dialog-condition-change.component.ts